// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-dashed[data-v-1b82238e]{border-style:dashed!important;border-width:2px!important}", ""]);
// Exports
module.exports = exports;
